
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("7HAe3", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $712741678e1ddc32$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Danish (Denmark)
var $712741678e1ddc32$export$2e2bcd8739ae039 = {
    'automation-menu.empty-state.image.alt': 'Ikon for tom automatiseringsliste',
    'automation-menu.empty-state.learn-more.link': "F\xe5 mere at vide om den manuelle udl\xf8ser",
    'automation-menu.modal.empty.automations.admin.description': "Brug den manuelle udl\xf8ser til at udfylde en menu med valgmuligheder, som alle, eller personer du angiver, kan anvende som automatiseringer med et enkelt klik.",
    'automation-menu.modal.empty.automations.user.description': "Administratorerne har endnu ikke konfigureret nogen manuelt udl\xf8ste automatiseringer.",
    'automation-menu.modal.error.description': "Dette tager et stykke tid at indl\xe6se. Pr\xf8v at genindl\xe6se siden.",
    'automation-menu.modal.error.image.alt': 'Fejlikon',
    'automation-menu.modal.footer.automate-button': 'Automatiser',
    'automation-menu.modal.footer.cancel-button': 'Annuller',
    'automation-menu.modal.footer.get-started-button': 'Opret automatisering',
    'automation-menu.modal.footer.ok-button': 'OK',
    'automation-menu.modal.header.icon.label': 'Ikon for overskrift for automatiseringsmodal',
    'automation-menu.success-state.message': 'Din automatisering er i gang',
    'fabric.linking.access_exists_description': 'Anmod om adgang til at se dette indhold fra {hostname}.',
    'fabric.linking.actions': 'Handlinger',
    'fabric.linking.add_account': "Tilf\xf8j konto",
    'fabric.linking.ai_summarize': 'Opsummer',
    'fabric.linking.ai_summarized': 'Opsummeret af Atlassian Intelligence',
    'fabric.linking.ai_summarized_abbreviation': 'Opsummeret af AI',
    'fabric.linking.ai_summarized_info': "Informationskvaliteten kan variere. <a>F\xe5 mere at vide</a>",
    'fabric.linking.ai_summarized_info_short': 'Indholdskvaliteten kan variere',
    'fabric.linking.ai_summarizing': 'Atlassian Intelligence arbejder ...',
    'fabric.linking.ai_summary_action': 'Opsummer med AI',
    'fabric.linking.ai_summary_action_description': "Opsummer indholdet af dette link ved hj\xe6lp af Atlassian Intelligence.",
    'fabric.linking.ai_summary_error_acceptable_use_violation': 'Vi kan ikke vise resultaterne af denne oversigt, da det er i strid med <a>Atlassians politik for acceptabel brug</a>.',
    'fabric.linking.ai_summary_error_exceeding_context_length_error': 'Atlassian Intelligence kan ikke generere en oversigt lige nu, da der er for meget indhold at opsummere.',
    'fabric.linking.ai_summary_error_generic': "Atlassian Intelligence (AI) svarer ikke. Pr\xf8v igen senere, eller <a>kontroll\xe9r status for AI</a>.",
    'fabric.linking.ai_summary_error_hipaa_content_detected': "Atlassian Intelligence kunne ikke behandle din anmodning, da dit indhold indeholder links til HIPAA-begr\xe6nset indhold.",
    'fabric.linking.assigned_to': 'Tildelt til {context}',
    'fabric.linking.automation-action.confluence.page.modal.description': "Anvend en automatisering til <b>{name}</b>.{br}De tilg\xe6ngelige valg styres af Confluence- og omr\xe5deadministratorer.",
    'fabric.linking.automation-action.confluence.page.modal.title': 'Sideautomatiseringer',
    'fabric.linking.automation-action.icon.label': 'Ikon for automatisering',
    'fabric.linking.automation-action.title': 'Vis automatiseringsregler',
    'fabric.linking.automation-action.tooltip': "V\xe6lg en automatiseringsregel, der skal k\xf8res",
    'fabric.linking.beta': 'Beta',
    'fabric.linking.cancel': 'Annuller',
    'fabric.linking.cannot_connect': "Kan ikke oprette forbindelse. Pr\xf8v igen.",
    'fabric.linking.cannot_find_link': 'Kan ikke finde linket',
    'fabric.linking.check_this_link': "Kontroll\xe9r dette link",
    'fabric.linking.click_to_join': 'Tilmeld dig {context}',
    'fabric.linking.click_to_join_description': "Du er blevet godkendt, s\xe5 du kan deltage i {context} med det samme.",
    'fabric.linking.close': 'Luk',
    'fabric.linking.connect_account_description': "Vi \xe5bner en ny side for at hj\xe6lpe dig til at forbinde din {name}-konto",
    'fabric.linking.connect_link_account': "Forbind til forh\xe5ndsvisning",
    'fabric.linking.connect_link_account_card_view': 'Forbind',
    'fabric.linking.connect_link_account_card_view_description': "Tilknyt din {context}-konto, hvis du vil se en forh\xe5ndsvisning af dette link",
    'fabric.linking.connect_link_account_card_view_name': 'Forbind din {context}-konto',
    'fabric.linking.connect_to': 'Forbind til {name}',
    'fabric.linking.connect_unauthorised_account_action': 'Forbind til {context}',
    'fabric.linking.connect_unauthorised_account_description': "Tilknyt din {context}-konto for at samarbejde om arbejde p\xe5 tv\xe6rs af Atlassian-produkter.",
    'fabric.linking.connect_unauthorised_account_description_no_provider': "Tilknyt din konto for at samarbejde om arbejde p\xe5 tv\xe6rs af Atlassian-produkter.",
    'fabric.linking.continue': "Forts\xe6t",
    'fabric.linking.copied_summary_action_description': 'Kopierede oversigt til udklipsholder',
    'fabric.linking.copied_url_to_clipboard': 'Kopieret!',
    'fabric.linking.copy_summary_action': "Kopi\xe9r oversigt",
    'fabric.linking.copy_summary_action_description': "Kopi\xe9r oversigt",
    'fabric.linking.copy_url_to_clipboard': "Kopi\xe9r link",
    'fabric.linking.couldnt_load_link': "Af en ukendt \xe5rsag kunne vi ikke indl\xe6se dette link.",
    'fabric.linking.create_on_absolute': 'Oprettet {context}',
    'fabric.linking.create_on_relative': 'Oprettet: {context}',
    'fabric.linking.created_by': 'Oprettet af {context}',
    'fabric.linking.delete': 'Slet',
    'fabric.linking.direct_access': 'Tilmeld dig nu',
    'fabric.linking.direct_access_description': 'Dit team bruger {product} til at samarbejde, og du kan begynde at bruge det med det samme!',
    'fabric.linking.direct_access_title': 'Deltag i {product} for at se dette indhold',
    'fabric.linking.download': 'Hent',
    'fabric.linking.download_description': 'Download denne fil til dit lokale lager',
    'fabric.linking.download_file': 'Download fil',
    'fabric.linking.edit': 'Rediger',
    'fabric.linking.follow': "F\xf8lg",
    'fabric.linking.follow_goal': "F\xf8lg m\xe5l",
    'fabric.linking.follow_goal_description': "F\xf8lg dette m\xe5l for at f\xe5 meddelelser om opdateringer",
    'fabric.linking.follow_goal_error': "Vi st\xf8dte p\xe5 en fejl, mens vi fors\xf8gte at f\xf8lge m\xe5let. Kontroll\xe9r din forbindelse, eller opdater siden, og pr\xf8v igen.",
    'fabric.linking.follow_project': "F\xf8lg projektet",
    'fabric.linking.follow_project_description': "F\xf8lg for at f\xe5 meddelelser om dette projekt",
    'fabric.linking.follow_project_error': "Vi st\xf8dte p\xe5 en fejl under fors\xf8get p\xe5 at f\xf8lge projektet. Kontroll\xe9r din forbindelse, eller opdater siden, og pr\xf8v igen.",
    'fabric.linking.forbidden_access': 'Du har ikke adgang',
    'fabric.linking.forbidden_description': 'Kontakt din administrator for at anmode om adgang til {hostname}.',
    'fabric.linking.forbidden_title': 'Du har ikke adgang til dette indhold',
    'fabric.linking.generic_error_message': 'Der opstod en fejl',
    'fabric.linking.go_back': "G\xe5 tilbage",
    'fabric.linking.invalid_permissions': "Begr\xe6nset indhold",
    'fabric.linking.invalid_permissions_description': "Anmod om adgang, eller pr\xf8v med en anden konto for at se denne forh\xe5ndsvisning.",
    'fabric.linking.join_to_view': 'Deltag i {context} for at se denne sag',
    'fabric.linking.join_to_view-issue-term-refresh': 'Deltag i {context} for at se denne sag',
    'fabric.linking.learn_more_about_connecting_account': "F\xe5 mere at vide om, hvordan du knytter din konto til Atlassian-produkter.",
    'fabric.linking.learn_more_about_smart_links': "F\xe5 mere at vide om intelligente links.",
    'fabric.linking.link_safety_warning_message': "Linket {unsafeLinkText} f\xf8rer dig til et andet websted, <a>actual link here</a>",
    'fabric.linking.loading': "Indl\xe6ser ...",
    'fabric.linking.modified_on_absolute': 'Opdateret {context}',
    'fabric.linking.modified_on_relative': 'Opdateret: {context}',
    'fabric.linking.more_actions': 'Flere handlinger',
    'fabric.linking.more_information_about_this_work_item': 'Flere oplysninger om denne sag',
    'fabric.linking.no_access_title': 'Deltag i {product} for at se dette indhold',
    'fabric.linking.not_found_description': "Siden findes ikke, eller den kan v\xe6re \xe6ndret, efter at linket blev tilf\xf8jet.",
    'fabric.linking.not_found_title': 'Vi kan ikke vise dig denne {product}-side',
    'fabric.linking.open_issue_in_jira': "\xc5bn sag i Jira",
    'fabric.linking.open_issue_in_jira-issue-term-refresh': "\xc5bn sag i Jira",
    'fabric.linking.open_link_in_a_new_tab': "\xc5bn link i en ny fane",
    'fabric.linking.owned_by': 'Ejet af {context}',
    'fabric.linking.pending_request': 'Din anmodning om adgang afventer behandling',
    'fabric.linking.preview_close': "Luk forh\xe5ndsvisning",
    'fabric.linking.preview_description': "\xc5bn en forh\xe5ndsvisning i fuld sk\xe6rm af dette link",
    'fabric.linking.preview_improved': "\xc5bn forh\xe5ndsvisning",
    'fabric.linking.preview_max_size': "Vis fuld sk\xe6rm",
    'fabric.linking.preview_min_size': "Luk fuld sk\xe6rm",
    'fabric.linking.priority_blocker': 'Blokering',
    'fabric.linking.priority_critical': 'Kritisk',
    'fabric.linking.priority_high': "H\xf8j",
    'fabric.linking.priority_highest': "H\xf8jeste",
    'fabric.linking.priority_low': 'Lav',
    'fabric.linking.priority_lowest': 'Laveste',
    'fabric.linking.priority_major': "V\xe6sentlig",
    'fabric.linking.priority_medium': 'Middel',
    'fabric.linking.priority_minor': 'Mindre',
    'fabric.linking.priority_trivial': 'Triviel',
    'fabric.linking.priority_undefined': 'Ikke defineret',
    'fabric.linking.read_time': "Kan l\xe6ses p\xe5 {context} min.",
    'fabric.linking.related': 'Relateret',
    'fabric.linking.related_links_found_in': 'Fundet i',
    'fabric.linking.related_links_found_in_v2': 'Fundet i',
    'fabric.linking.related_links_includes_links_to': 'Omfatter links til',
    'fabric.linking.related_links_includes_links_to_v2': 'Omfatter links til',
    'fabric.linking.related_links_modal_error_description': "Kontroll\xe9r din forbindelse, eller opdater siden for at pr\xf8ve igen",
    'fabric.linking.related_links_modal_error_header': 'Noget gik galt',
    'fabric.linking.related_links_modal_error_message': "Vi l\xf8b ind i et problem, da vi fors\xf8gte at indl\xe6se nylige links. Kontroll\xe9r din forbindelse, eller genindl\xe6s siden for at pr\xf8ve igen.",
    'fabric.linking.related_links_modal_error_title': "Vi har problemer med at indl\xe6se relaterede links",
    'fabric.linking.related_links_modal_title': 'Seneste links',
    'fabric.linking.related_links_modal_title_v2': 'Relaterede links',
    'fabric.linking.related_links_modal_unavailable_description': "Vi gennemg\xe5r l\xf8bende og tilf\xf8jer relaterede links til opdaterede sider eller andre indholdstyper",
    'fabric.linking.related_links_modal_unavailable_header': 'Ingen nylige links',
    'fabric.linking.related_links_modal_unavailable_message': "Vi fandt ikke nogen links at vise her. Vi gennemg\xe5r l\xf8bende og tilf\xf8jer nylige links til opdaterede sider eller andre indholdstyper.",
    'fabric.linking.related_links_modal_unavailable_title': 'Vi kunne ikke finde nogen relaterede links',
    'fabric.linking.related_links_not_found': 'Vi fandt ikke nogen links.',
    'fabric.linking.related_links_view_related_links': 'Se relaterede links',
    'fabric.linking.related_links_view_related_urls': 'Vis nylige links',
    'fabric.linking.request_access': 'Anmod om adgang',
    'fabric.linking.request_access_description': 'Dit team bruger {product} til at samarbejde. Send din administrator en anmodning om adgang.',
    'fabric.linking.request_access_pending': 'Afventer godkendelse',
    'fabric.linking.request_access_pending_description': 'Din anmodning om adgang til {hostname} afventer administratorens godkendelse.',
    'fabric.linking.request_access_pending_title': 'Afventer adgang til {product}',
    'fabric.linking.request_access_to_view': 'Anmod om adgang til {context} for at se denne sag',
    'fabric.linking.request_access_to_view-issue-term-refresh': 'Anmod om adgang til {context} for at se denne sag',
    'fabric.linking.request_denied': 'Din anmodning om adgang blev afvist',
    'fabric.linking.request_denied_description': "Din administrator godkendte ikke din anmodning om at f\xe5 vist {product}-sider fra {hostname}.",
    'fabric.linking.restricted_link': "Begr\xe6nset link. Pr\xf8v en anden konto",
    'fabric.linking.retry': "Pr\xf8v igen",
    'fabric.linking.save': 'Gem',
    'fabric.linking.sent_on_absolute': 'Sendt den {context}',
    'fabric.linking.sent_on_relative': 'Sendt for {context}',
    'fabric.linking.srclink': 'Vis i',
    'fabric.linking.srclinkunknown': 'Vis original',
    'fabric.linking.status_change_load_error': "Vi kunne ikke indl\xe6se statusser og overf\xf8rsler",
    'fabric.linking.status_change_permission_error': "Du har ikke tilladelse til at overf\xf8re denne sag.",
    'fabric.linking.status_change_permission_error-issue-term-refresh': "Du har ikke tilladelse til at overf\xf8re denne sag.",
    'fabric.linking.status_change_update_error': 'Vi kunne ikke opdatere statussen',
    'fabric.linking.try_again': "Pr\xf8v igen",
    'fabric.linking.try_another_account': "Pr\xf8v en anden konto",
    'fabric.linking.unassigned': 'Ikke tildelt',
    'fabric.linking.unauthorised_account_description': "Du fors\xf8ger at f\xe5 vist et link til en privat {context}-side. Vi anbefaler, at du gennemg\xe5r URL'en eller kontakter sideejeren.",
    'fabric.linking.unauthorised_account_description_no_provider': "Du fors\xf8ger at f\xe5 vist et link til en privat side. Vi anbefaler, at du gennemg\xe5r URL'en eller kontakter sideejeren.",
    'fabric.linking.unauthorised_account_name': 'Vi kan ikke vise private sider fra {context}',
    'fabric.linking.unauthorised_account_name_no_provider': 'Vi kan ikke vise private sider',
    'fabric.linking.unfollow': "Oph\xf8r med at f\xf8lge",
    'fabric.linking.unfollow_goal': "Stop med at f\xf8lge m\xe5l",
    'fabric.linking.unfollow_goal_description': "Stop med at f\xf8lge for at stoppe med at modtage meddelelser om dette m\xe5l",
    'fabric.linking.unfollow_goal_error': "Vi st\xf8dte p\xe5 en fejl, mens vi fors\xf8gte at stoppe med at f\xf8lge m\xe5let. Kontroll\xe9r din forbindelse, eller opdater siden, og pr\xf8v igen.",
    'fabric.linking.unfollow_project': "Stop med at f\xf8lge projektet",
    'fabric.linking.unfollow_project_description': "Stop med at f\xf8lge for at stoppe modtagelse af projektmeddelelser",
    'fabric.linking.unfollow_project_error': "Vi st\xf8dte p\xe5 en fejl under fors\xf8get p\xe5 at stoppe med at f\xf8lge projektet. Kontroll\xe9r din forbindelse, eller opdater siden, og pr\xf8v igen.",
    'fabric.linking.unlink_account': 'Fjern link til konto',
    'fabric.linking.updated_by': "\xc6ndret af {context}",
    'fabric.linking.view': 'Vis'
};

});


//# sourceMappingURL=da.fe381429.js.map
